import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { FrameworkComponent } from 'src-private/app/shared/framework/framework.component';

import { environment } from '../../../../../../../environments/environment';

/*--  Interfaces --*/
import { INote, INoteGroup } from '../../../../interfaces/note.interface';

/*-- Services --*/
import { DealersService } from '../../../../services/dealers.service';
import { ToastrService } from 'ngx-toastr';

/*-- Third Party --*/
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { faSave, faThumbtack, faWindowClose} from '@fortawesome/free-solid-svg-icons';
import { faThumbtack as faThumbtackRegular} from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-add-note',
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.scss']
})
export class AddNoteComponent extends FrameworkComponent implements OnInit, AfterViewInit {
  @BlockUI() blockUI: NgBlockUI;

  public editorConfig = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
    ],
  };

  public dealerId: number;
  public noteGroups: INoteGroup[];
  public title: string;
  public isPinned: boolean;

  public isSubmitted: boolean;
  public noteForm: UntypedFormGroup;
  public faSave = faSave;
  public faWindowClose = faWindowClose;
  public faThumbtackSolid = faThumbtack;
  public faThumbtackRegular = faThumbtackRegular;
  constructor(
    private dealersService: DealersService,
    private toastrService: ToastrService,
    private dialogRef: MatDialogRef<AddNoteComponent>,
    @Inject(MAT_DIALOG_DATA) data
    ) {
    super();
    this.dealerId = data.dealerId;
    this.noteGroups = data.noteGroups;
    this.title = data.title;
    this.isPinned = false;
  }

  //#region - Lifecycle
  ngOnInit(): void {
    this.noteForm = new UntypedFormGroup({
      noteGroup: new UntypedFormControl(null, [Validators.required]),
      noteText: new UntypedFormControl(),
    });
  }

  ngAfterViewInit(): void {
    super.build("AddNoteComponent", "add-dealer-note-dialog-component");
  }
  //#endregion

  //#region - Getters
  get f() { return this.noteForm.controls; }
  //#endregion

  //#region - Events
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onFormSubmit(): void {
    this.isSubmitted = true;

    if (this.noteForm.valid) {
      this.blockUI.start();

      this.createNote().then(
        () => {
          this.dialogRef.close(true);
          this.blockUI.stop();
        }
      );
    }
  }

  onPinClicked(): void {
    this.isPinned = !this.isPinned;
  }
  //#endregion

  //#region - API Methods
  private createNote(): Promise<{}> {
    const note = {} as INote;
    const title = 'Add Note';

    note.comment = this.noteForm.controls['noteText'].value;
    note.isPinned = this.isPinned;
    note.vendorId = this.dealerId;
    note.noteGroupId = this.noteForm.controls['noteGroup'].value;

    const promise = new Promise((resolve, reject) => {
      this.dealersService.noteCreate(note).subscribe(
        () => {
          this.toastrService.success('Your note has been successfully added.', title);

          resolve(true);
        },
        () => {
          this.toastrService.error(environment.messages.apiError, title);

          reject();
        }
      );
    });

    return promise;
  }
  //#endregion
}
